<table style="width:100%" class="contentDisplay">
    <tr>
        <td class="left">
                <img
                    class="home-page-image"
                    src="assets/images/bannerhome1.jpg"
                    width="323px"
                    height="140px"
                    alt=""
                >
                <img
                    class="home-page-image"
                    src="assets/images/bannerhome2.jpg"
                    width="160px"
                    height="140px"
                    alt=""
                    title=
                        "Credit: R. J. Wilson, Ph.D.
        C. M. Earhart, Ph.D.
        S. X. Wang, Ph.D."
                >
                <img
                    class="home-page-image"
                    src="assets/images/bannerhome3.jpg"
                    width="113px"
                    height="140px"
                    alt=""
                    title="Credit: Brenda Melendez
        and Rita Serda, Ph.D."
                >

                <div class="welcome">
                    <div class="welcomeTitle">
                       <b>Welcome to caNanoLab</b>
                    </div>
                    <div class="welcomeContent p-3">
                        Welcome to the cancer Nanotechnology Laboratory (caNanoLab) portal. caNanoLab is a data sharing portal designed to facilitate information sharing across the international biomedical
                        nanotechnology research community to expedite and validate the use of nanotechnology in biomedicine. caNanoLab provides support for the annotation of nanomaterials with characterizations
                        resulting from physico-chemical, <i>in vitro</i> and <i>in vivo</i> assays and the sharing of these characterizations and associated nanotechnology protocols in a secure fashion.
                    </div>

                </div>

                <canano-browse-cananolab></canano-browse-cananolab>

        </td>
        <td class="right">
            <canano-right-side-bar></canano-right-side-bar>
        </td>
    </tr>
</table>
